import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { IconNames, Icon } from '@components/icon';
import { Typography } from '@components/typography';
import { getOptionStylesAsClassName, getOptionIconStylesAsClassName } from './option-styles';
import { twMerge } from 'tailwind-merge';
export interface IOptionProps {
  /** Value this option represents */
  value: string | Record<string, unknown>;
  /** Handles click event from parent passing the value */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, value: string | Record<string, unknown>) => void;
  /** Changes the visual aspect of the Option */
  selected?: boolean;
  /** Changes the visual aspect of the Option */
  focused?: boolean;
  /** Shows the checkmark icon on the right side when selected */
  showTick?: boolean;
  /** Handles mouse enter event */
  onMouseEnter?: (value: string | Record<string, unknown>) => void;
}
export const Option = t0 => {
  const $ = _c(31);
  let children;
  let classNameProp;
  let onClick;
  let onMouseEnter;
  let rest;
  let t1;
  let t2;
  let t3;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onClick,
      onMouseEnter,
      selected: t1,
      focused: t2,
      showTick: t3,
      children,
      className: classNameProp,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = classNameProp;
    $[3] = onClick;
    $[4] = onMouseEnter;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = value;
  } else {
    children = $[1];
    classNameProp = $[2];
    onClick = $[3];
    onMouseEnter = $[4];
    rest = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    value = $[9];
  }
  const selected = t1 === undefined ? false : t1;
  const focused = t2 === undefined ? false : t2;
  const showTick = t3 === undefined ? true : t3;
  let t4;
  if ($[10] !== onClick || $[11] !== value) {
    t4 = event => {
      onClick && onClick(event, value);
    };
    $[10] = onClick;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleOnClick = t4;
  let t5;
  if ($[13] !== classNameProp || $[14] !== focused || $[15] !== selected) {
    t5 = twMerge(getOptionStylesAsClassName(selected, focused), classNameProp);
    $[13] = classNameProp;
    $[14] = focused;
    $[15] = selected;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const tailwindClassName = t5;
  let t6;
  if ($[17] !== onMouseEnter || $[18] !== value) {
    t6 = () => onMouseEnter?.(value);
    $[17] = onMouseEnter;
    $[18] = value;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== selected || $[21] !== showTick) {
    t7 = selected && showTick && <Icon className={getOptionIconStylesAsClassName} name={IconNames.CHECK} />;
    $[20] = selected;
    $[21] = showTick;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== children || $[24] !== handleOnClick || $[25] !== rest || $[26] !== selected || $[27] !== t6 || $[28] !== t7 || $[29] !== tailwindClassName) {
    t8 = <Typography component="button" type="button" className={tailwindClassName} variant="body2" bold={selected} role="menuitem" onClick={handleOnClick} onMouseEnter={t6} {...rest}>{children}{t7}</Typography>;
    $[23] = children;
    $[24] = handleOnClick;
    $[25] = rest;
    $[26] = selected;
    $[27] = t6;
    $[28] = t7;
    $[29] = tailwindClassName;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};